import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import Hero from './components/Hero';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import Newsletter from './components/Newsletter';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '熟女魅力 - 成熟女性的时尚与生活美学',
  description: '探索熟女的独特魅力，从时尚穿搭、护肤保养到生活态度，全面解析成熟女性如何展现自信与优雅。为30岁以上女性提供实用的风格指南与生活美学建议。',
  url: 'https://elegantvibe.github.io/',
  isPartOf: {
    '@type': 'WebSite',
    name: '熟女魅力',
    url: 'https://elegantvibe.github.io/',
  },
  about: {
    '@type': 'Organization',
    name: '熟女魅力',
    description: '专注为30岁以上成熟女性提供时尚穿搭、护肤保养、生活美学与自我成长的优质内容平台。',
    url: 'https://elegantvibe.github.io/',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="熟女魅力 - 成熟女性的时尚穿搭、护肤保养与生活美学指南"
        description="探索熟女的独特魅力，从时尚穿搭、护肤保养到生活态度，全面解析成熟女性如何展现自信与优雅。为30岁以上女性提供实用的熟女风格指南、熟女生活美学建议，让熟女魅力更加耀眼动人。"
        keywords="熟女,熟女穿搭风格,熟女护肤保养,成熟女性魅力,熟女时尚指南,熟女生活美学,熟女自信气质"
        canonicalUrl="https://elegantvibe.github.io/"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema, null, 2) }}
      />
      <Navbar />
      <main>
        <Hero />
        <FeaturedArticles />
        <CategoryGrid />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
}